import React from 'react';
import { combineClassNames } from '../../../../app/functions';
import hotInsuranceLogoPath from '../../../../assets/logos/hot-insurance-logo.svg';
import './index.scss';

const ScreenLoader = ({ isVisible = false }) => (
    <div
        className={combineClassNames(
            'screen-loader',
            isVisible && 'screen-loader_visible',
        )}
        role="progressbar"
        aria-label="Loading Screen"
        aria-busy={isVisible}
    >
        <img src={hotInsuranceLogoPath} alt="Hot Insurance" className="screen-loader-logo" />
    </div>
);

export default ScreenLoader;
